function LifeCommand() {
  return '=42';
}

export default LifeCommand;



// WEBPACK FOOTER //
// ./src/commands/LifeCommand.js